import React from "react";
import { TextField } from "@material-ui/core";
import PropTypes from "prop-types";

const EntityTableFilter = ({ expression, setExpression, ...rest }) => (
  <TextField
    label="Table Filter"
    placeholder="Enter an expression..."
    variant="outlined"
    InputLabelProps={{
      shrink: true,
    }}
    value={expression}
    onChange={(event) => setExpression(event.target.value)}
    {...rest}
  />
);

export default EntityTableFilter;

EntityTableFilter.propTypes = {
  expression: PropTypes.string.isRequired,
  setExpression: PropTypes.func.isRequired,
};
